'use client';

export default function CompanyName() {
  return (
    <span
      onClick={() => {
        if (process.env.NODE_ENV_API === 'test' && process.env.NODE_ENV === 'production') {
          window?.eruda?.init();
        }
      }}
    >
      重庆霏微科技有限公司
    </span>
  );
}
